import { FC, createContext, useContext } from 'react';
import { useGroupSelection } from 'utils/hooks/useGroupSelection';
import noop from 'utils/noop';

export type SelectionContextState = {
  selected: (string | number)[];
  selectByIds: (ids: (string | number)[]) => void;
  toggleSelection: (ids: string | number) => void;
  deselectByIds: (ids: (string | number)[]) => void;
  deselectAll: () => void;
};

const defaultState = {
  selected: [],
  selectByIds: noop,
  toggleSelection: noop,
  deselectByIds: noop,
  deselectAll: noop,
};

export const SelectionContext = createContext<SelectionContextState>(defaultState);

export const SelectionContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { selected, selectByIds, toggleSelection, deselectAll } = useGroupSelection();

  const deselectByIds = (ids: (string | number)[]) => {
    selectByIds(selected.filter((id) => !ids.includes(id)));
  };

  return (
    <SelectionContext.Provider
      value={{
        selected,
        selectByIds,
        toggleSelection,
        deselectByIds,
        deselectAll,
      }}
    >
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelectionContext = () => useContext(SelectionContext);
